<template>
  <site-link
    :to="$category({ name: category.id })"
    class="card category-card display-flex flex-column align-around"
    style="--card-margin-bottom: 0"
    @click.native="$posthog.capture('icons_landing:category_link_click', { category: category.id })"
  >
    <div class="padding-y-sm">
      <slot name="visuals">
        <i :class="`fas fa-${category.icon} fa-fw size-3xl`" />
      </slot>
    </div>

    <p
      class="size-xs text-uppercase"
      style="
        font-weight: var(--font-weight-bold);
        hyphens: auto;
        letter-spacing: var(--letter-spacing-2xl);
        line-height: var(--line-height-sm);
        overflow-x: clip;
        text-overflow: ellipsis;
      "
    >
      {{ category.label }}<span class="sr-only"> icons</span>
    </p>
  </site-link>
</template>

<script>
  export default {
    name: 'CategoryCard',

    props: {
      category: {
        type: Object,
        required: true
      },
      isLast: {
        type: Boolean,
        default: false
      }
    }
  }
</script>
